module.exports = __webpack_public_path__ + "static/media/home-1.697cfcce.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/home-1.svg
// module id = 1324
// module chunks = 1